module.exports = __webpack_public_path__ + "static/gond-symbol-SCAG-9d0758e5410133e3c5f73ec63060d8c7.png";